import { jsx, Fragment } from '@emotion/react/jsx-runtime';
import { useDetectInputMethod } from '../../hooks/useDetectInputMethod.js';
import { renderProp } from '../../utils/renderProp.js';
import { useMenuDropdownContext } from '../MenuContext/MenuProvider.js';

var createKeyDownHandler = function (_a) {
    var setIsOpen = _a.setIsOpen;
    return function (event) {
        switch (event.code) {
            // case "Tab" is for scenerio that all items are disabled
            case "Tab":
            case "Escape":
                setIsOpen(false);
                break;
            // case "ArrowDown" is required for menu button based on https://www.w3.org/TR/wai-aria-practices-1.2/examples/menu-button/menu-button-actions-active-descendant.html
            case "Space":
            case "ArrowDown":
                event.preventDefault();
                event.stopPropagation();
                setIsOpen(true);
                break;
        }
    };
};
var useMenuButton = function () {
    var context = useMenuDropdownContext();
    var id = context.id, isOpen = context.isOpen, triggerRef = context.triggerRef;
    var isUsingKeyboard = useDetectInputMethod().isUsingKeyboard;
    var keyDownHandler = createKeyDownHandler(context);
    var clickHandler = function () {
        // focus first element if triggered by keyboard
        if (isUsingKeyboard()) {
            setTimeout(function () {
                var _a;
                (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
    };
    return {
        props: {
            type: "button",
            "aria-controls": "".concat(id, "-dropdown"),
            "aria-expanded": isOpen,
            id: id,
            onKeyDown: keyDownHandler,
            onClick: clickHandler,
        },
    };
};
var MenuButtonRenderProp = function (_a) {
    var children = _a.children;
    var returnVal = useMenuButton();
    return jsx(Fragment, { children: renderProp({ prop: children, context: returnVal }) });
};

export { MenuButtonRenderProp, useMenuButton };
//# sourceMappingURL=useMenuButton.js.map
